<template>
  <v-card class="pa-0 pa-md-6" elevation="0">
    <v-card-text class="py-5" ref="content">
      <div class="mb-4">
        <swiper :options="swiperOptions" ref="el">
          <template v-for="(image, i) in current.images">
            <swiper-slide :key="i">
              <v-responsive :aspect-ratio="1">
                <v-card class="fill-height position-relative" outlined>
                  <ProxyImage :src="image"/>
                </v-card>
              </v-responsive>
            </swiper-slide>
          </template>
        </swiper>
      </div>

      <div class="d-flex flex-column align-start fill-width">
        <div>{{ current.description || 'No caption' }}</div>
      </div>

      <v-divider class="my-4 mb-8"></v-divider>

      <ValidationObserver ref="observer">
        <form>
          <ValidationProvider name="name" rules="required" v-slot="{ errors }">
            <v-text-field
              :disabled="adding"
              :error-messages="errors"
              dense
              label="Name"
              v-model="values.name"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="price" rules="required" v-slot="{ errors }">
            <v-text-field
              :disabled="adding"
              :error-messages="errors"
              dense
              label="Price"
              type="number"
              v-model="values.price"
            ></v-text-field>
          </ValidationProvider>
        </form>

        <div class="d-flex mt-6">
          <v-btn @click="createItem" class="flex-grow-1" color="primary" elevation="0" :loading="adding">
            Add to products
          </v-btn>
        </div>
      </ValidationObserver>
    </v-card-text>

    <v-snackbar :color="toast.color || ''" top v-model="toast.visible">
      {{ toast.message }}
    </v-snackbar>
  </v-card>
</template>

<script>
import ProxyImage from "@/components/ProxyImage";

export default {
  name: "InstagramDetails",
  components: { ProxyImage },
  props: {
    current: {
      type: Object,
      required: true
    }
  },
  created() {
    this.values = {
      name: this.current.values.name ?? '',
      price: this.current.values.price ?? '',
    }
  },
  data() {
    return {
      adding: false,
      values: {
        name: '',
        price: '',
      },
      toast: {
        visible: false,
        color: 'orange',
        message: ''
      },
      swiperOptions: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 2.5
          },
          700: {
            slidesPerView: 3.5
          },
          900: {
            slidesPerView: this.columns
          }
        }
      }
    }
  },
  methods: {
    async createItem() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      this.adding = true;
      const payload = {
        name: this.values.name,
        price: this.values.price,
        primary_picture: this.current.images[0],
        secondary_picture: this.current.images[1] ?? '',
        tertiary_picture: this.current.images[2] ?? '',
        fourth_picture: this.current.images[3] ?? '',
        fifth_picture: this.current.images[4] ?? '',
        slug: this.$route.params.mid,
        caption: this.current.description,
        sell_on_credit: "1"
      };
      const res = await this.$http.post('https://sellbackend.creditclan.com/merchantclan/public/index.php/api/merchant/status/item', payload);
      if (res.data.status) {
        this.$emit('done');
      } else {
        this.toast = {
          visible: true,
          color: 'red',
          message: res.data.message || 'An error occurred, please try again'
        }
      }
      this.adding = false;
    }
  }
}
</script>
